import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div" }) => {
  const Comp = motion[as];
  return (
    <Comp
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.12 }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </Comp>
  );
};

export const Eyebrow = ({ children, light = false }) => (
  <p className={`ks-eyebrow ${light ? "text-[#8a6d2f]" : "text-[#CDA85B]"}`}>
    <span className="ks-eyebrow-line" aria-hidden="true" />
    {children}
  </p>
);
